export const DEFAULT_SAL_PROPS = {
  'data-sal': 'slide-up',
  'data-sal-duration': 500,
  'data-sal-easing': 'ease'
};

/**
 * Use this const to space out reveals per slide
 * e.g. if you want 2 elements to come in one after the other use
 * data-sal-delay={SAL_DELAY * 1} on the 1st element
 * data-sal-delay={SAL_DELAY * 2} on the 2nd element
 */
export const SAL_DELAY = 150;
